<template>
	<div id="Main">
		<div class="content">
			<div class="tisp"><van-image width="2.1rem" fit="contain" :src="require('../../assets/images/notice/danger.png')" />风险提示</div>
			<div class="textbox">
				<p class="textp"><span class="icon"></span>公司进行上市、挂牌、增发、配售等资本运作一定要做到依法合规，严格按照《公司法》、《证券法》、《非上市公众公司监督管理办法》等法律法规规定，认真履行相关报批、报备手续。未经批准不得擅自增发、配售股份，不能损害股东特别是中小股东的合法权益，不能引发影响社会稳定的不安定因素。</p>
				<p class="textp"><span class="icon"></span>投资者一定要仔细了解国家关于非上市公司相关政策法规，充分认识到投资非上市公司股权可能带来的经济风险和法律风险，不要盲目相信他人有关公司上市、挂牌、增发、配售、转让的宣传或者承诺，提高警惕，谨防上当受骗。</p>
			</div>
			
		</div>
		<footerbox></footerbox>
	</div>
</template>
<script>
	import footerbox from '../../components/footer';
	export default {
		components: {
			footerbox,
		},
		data() {
			return {
			}
		},
		methods: {

		},
		mounted() {


		},

	}
</script>

<style lang="scss" scoped>
	#Main {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		.content{
			background:#fff url('../../assets/images/notice/risk.png') no-repeat right center;
			background-size: 100%;
			flex: 1;
			.tisp{
				padding:2.4rem 1.3rem 1.6rem;
				color: #d9261c;
				font-size: 2.3rem;
				font-weight: bold;
				text-align: left;
				line-height: 3rem;
				border-bottom: 1px solid #fff;;
				.van-image{
					vertical-align:0.1rem;
					margin-right: 1rem;
				}
			}
			.textp{
				font-size: 1.4rem;
				text-align: left;
				line-height: 2.4rem;
				margin-bottom: 2rem;
				color: #333333;
				text-indent:1.6rem;
				.icon{
					display: inline-block;
					margin-right: 5px;
					width: 0.8rem;
					height: 0.8rem;
					border-radius: 2px;
					background-color: #fa6b6b;
				}
			}
			.textbox{
				padding:2rem 1.3rem;
			}
		}
	}
</style>
